import dayjs from 'dayjs';

const STALE_THRESHOLD_HOURS = 60;

export function getErpSyncColor(timestamp: string | null): string {
  if (timestamp === null) {
    return 'grey';
  }
  return dayjs().diff(dayjs(timestamp), 'hour') <= STALE_THRESHOLD_HOURS
    ? 'success'
    : 'warning';
}
